import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconModeDarkStyle0 = cosmosIconCss;

const CosmosIconModeDark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconModeDark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '50f2b840dbae3778a04ee2042869ddfeb3d12ddf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '89bff945a76a6205fac15c69222dc5a11eef1d56', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4b78cccf6486ae78d726ccb0a3301b9ed457b0be', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.125 14.413a4.5 4.5 0 1 1-5.388-7.185 6.502 6.502 0 0 0 5.388 7.185Zm1.1-1.413h-.034a5 5 0 0 1-4-8 5.993 5.993 0 0 0-6 6 6 6 0 0 0 11.762 1.68 4.99 4.99 0 0 1-1.729.32Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconModeDarkStyle0; }
}, [1, "cosmos-icon-mode-dark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mode-dark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mode-dark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconModeDark$1);
            }
            break;
    } });
}

const CosmosIconModeDark = CosmosIconModeDark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconModeDark, defineCustomElement };
